import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { errorFormatter } from '../utils/errorFunctions'

const reload = () => window.location.reload()

const GEOSERVER_API = gql`
    mutation geoserverApi($input: geoserverApiInput!) {
        geoserverApi(input: $input) {
            itemId
            fileName
            action
            statusCode
        }
    }
`


export default function GeoserverModal(props) {

  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  const [showClose, setShowClose] = useState(false)

  const handleClose = () => {
    props.onHide()
    reload()
  }

  let title = ''
  let action = ''
  let fileType = ''
  const dataAction = props.action
  if (dataAction === 'createShapefile'){
    title = 'Create Geoserver Shapefile Service'
    action = 'create'
    fileType = 'shapefile'
  } else if (dataAction === 'createRaster'){
    title = 'Create Geoserver Raster Service'
    action = 'create'
    fileType = 'raster'
  } else if (dataAction === 'deleteShapefile'){
    title = 'Delete Geoserver Shapefile Service'
    action = 'delete'
    fileType = 'shapefile'
  } else if (dataAction === 'deleteRaster'){
    title = 'Delete Geoserver Raster Service'
    action = 'delete'
    fileType = 'raster'
  } 

  const [geoserver_api] = useMutation(
    GEOSERVER_API,
    {
      variables: {
        input: {
          itemId: props.itemId,
          fileName: props.row.name,
          fileType: fileType,
          action: action
        }
      }
    }
  )

  return (
    <Modal {...props} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            setIsLoading(true)
            e.preventDefault()
            geoserver_api().then(              
              result => {
                console.log('result', result)
                reload()
              },
              error => {
                console.log('{title} failed with error: ', error)
                props.onHide()
                setIsLoading(false)
              }
            )
          }}
        >
          <h3>You are about to create a new geospatial service from this shapefile.</h3>
          <Modal.Footer>
            <Button variant='secondary' onClick={props.onHide}>Close</Button>
            {isComplete ? '' : <Button variant="primary" type="submit">{isLoading ? <span ><FontAwesomeIcon icon={faSpinner} pulse /></span> : ''}&nbsp;{title} </Button>}
            </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

GeoserverModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    pathOnDisk: PropTypes.string,
    contentType: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
  action: PropTypes.string,
}
